// extracted by mini-css-extract-plugin
var _1 = "y7ZNAYiADhKEaQoPKQfC";
export { _1 as "errorPage" }
